/** A type for the team id, or literal "org" when full organization is selected. */
export type TeamIdOrOrg = "org" | (string & {}); // eslint-disable-line @typescript-eslint/ban-types

/** Filter the given list of entities to only those within a certain team. If the specified team
 * is "org", all entities are returned. */
export const teamFilter =
  (teamId: TeamIdOrOrg) =>
  <T extends { teamId?: string }>(list: T[]): T[] => {
    return teamId !== "org"
      ? list.filter((item) => item.teamId && item.teamId === teamId)
      : list;
  };
